import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { useMessage } from '../i18n/useMessage';

export const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  display: block;
  border: 0;
  flex-grow: 1;
`;

export interface IframeModuleProps {
  src: string;
  title?: string;
}

export const IframeModule = ({ title, ...props }: IframeModuleProps) => {
  const t = useMessage();
  const moduleTitle = title ? ` - ${title}` : '';

  return (
    <>
      <Helmet title={`${moduleTitle} | ${t('default-page-title')}`} />
      <StyledIframe title={title} {...props} />
    </>
  );
};
